import React, { useState } from 'react'
import { Col, Row,Tooltip} from 'reactstrap';
import infoIcon from '../../../assets/icons/info.png'
import allForms from '../../../utils/AllCompaigns.json';
import archivedForms from '../../../utils/AllArchived.json';
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
function GS_ProcessPipelines({userWantInfoAgain,setUserWantInfoAgain}) {
  const BASE_URL = "https://htj5xy3nrv.us-east-1.awsapprunner.com";
  // const BASE_URL = "http://localhost:8080";
  console.log(allForms)
  const dispatch = useDispatch();
  const user = useSelector((state) => state.userInfo);
  const appInfo = useSelector(state=>state.appInfo);
  const [loading, setLoading] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);
 

  const setUserWantInfoAgain1 = () =>{
    console.log("userWantInfoAgain",userWantInfoAgain)
    setUserWantInfoAgain(true)
}

  const handleRequestAccess = async (Form) => {
    setSelectedForm(Form)
    setLoading(true);
    await axios
      .post(`${BASE_URL}/api/nCount/odk/central-user-form-access`, {
        projectId: Form.projectId,
        formId: Form.formId,
        roleId: Form.roleId,
        userId: user.odkUserId,
        location:user.location
      })
      .then(function (response) {
        setLoading(false);
        alert("You have the form access now.");
        // dispatch({ type: "UPDATE_ODK_FORM_ACCESS", payload: response.data });
        setSelectedForm(null);
      })
      .catch(function (error) {
        setLoading(false);
        alert("You already have this form access.");
        setSelectedForm(null);
        setLoading(false);
        console.log(error);
      });
  };

  return (
    <>
    <div className='gs-data-collection-forms-div'>
        <Row>
    {
        allForms.map((form)=>{
          console.log(form.location,user.location)
      
            return (
                <Col md="4" key={`active-${form.formId}`}>
               <div className='gs-formname-div' onClick={()=>handleRequestAccess(form)}>
                <p className='gs-formname-text1'>{!(loading && form.formId==selectedForm?.formId)?form.name:'Loading...'}</p>
                <p className='gs-formname-text2'>{form.name2}</p>
               </div>
            </Col>
            )
 
            })
            }
      
        </Row>
        {/* <div className='gs-info-icon-div'>
            <img className='gs-info-icon' src={infoIcon} onClick={()=>setUserWantInfoAgain1()}/>
            </div> */}
    </div>
    </>
  )
}

export default GS_ProcessPipelines